/* @flow */

const getEntregadoresId = (entregadores: Object): ?number => {
    const select = document.getElementById('entregador-atendimento');

    if (!(select instanceof HTMLInputElement) || !select.value) {
        return null;
    }

    const entregador = entregadores.find(e => e.nome === select.value);

    return Number(entregador.id);
};

export default getEntregadoresId;
